/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _isInitialized;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import { service } from "@ember/service";
import { capitalize } from "@ember/string";
import Component from "@glimmer/component";
import IntlService from "ember-intl/services/intl";
import { modifier } from "ember-modifier";
import $ from "jquery";
let BasicRadioComponent = (_class = (_isInitialized = /*#__PURE__*/new WeakMap(), class BasicRadioComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _classPrivateFieldInitSpec(this, _isInitialized, false);
    _defineProperty(this, "updateRadioModifier", modifier(element => {
      if (!_classPrivateFieldGet(_isInitialized, this)) this._setup(element);
      this._updateChecked(element);
      this._updateDisabled(element);
    }));
  }
  get elementId() {
    return guidFor(this);
  }
  get dataTestRadioFor() {
    return this.args.dataTestValue || this.args.propertyName + "-" + this.args.value;
  }
  get label() {
    if (this.args.label) return this.args.label;
    if (this.args.translationKey) return capitalize(this.intl.t(`${this.args.translationKey}.${this.args.value}`));
    return "";
  }
  _updateDisabled(element) {
    if (this.args.disabled || this.args.isReadOnly) {
      /** @ts-expect-error TODO */
      $(element).checkbox("set disabled");
    } else {
      /** @ts-expect-error TODO */
      $(element).checkbox("set enabled");
    }
  }
  _updateChecked(element) {
    if (this.args.value == this.args.current) {
      /** @ts-expect-error TODO */
      $(element).checkbox("set checked");
    } else {
      /** @ts-expect-error TODO */
      $(element).checkbox("set unchecked");
    }
  }
  _setup(element) {
    /** @ts-expect-error TODO */
    $(element).checkbox({
      onChange: () => {
        /** @ts-expect-error TODO */
        if ($(element).checkbox("is checked")) {
          this.args.onChange(this.args.value);
        }
      }
    });
    _classPrivateFieldSet(_isInitialized, this, true);
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_updateDisabled", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_updateDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateChecked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_updateChecked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_setup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_setup"), _class.prototype), _class);
export { BasicRadioComponent as default };